export default __webpack_public_path__ + "assets/mist.e61faee5.svg";